import { connect } from 'react-redux'
import getInfoModalIsOpen from '../../reducers/userAccount/selectors/infoModal'
import togglePremiumInfoModal from '../../actions/userAccount/limit/togglePremiumInfoModal'
import PremiumInfoModal from './PremiumInfoModal'

const mapStateToProps = state => ({
  open: getInfoModalIsOpen(state),
})

const mapDispatchToProps = (dispatch) => ({
  close: () => dispatch(togglePremiumInfoModal()),
})

const InfoModal = connect(mapStateToProps, mapDispatchToProps)(PremiumInfoModal)

export default InfoModal
